/*
  GiftGo category strip auto-scroller.

  The strip is a normal horizontally scrollable row, so the shopper can swipe or
  drag it themselves at any time. When idle it drifts on its own and loops.

  Mobile fix: many phones report element.scrollLeft as a whole number, so adding
  a fractional speed each frame never accumulates and the row sits still. We keep
  the position in a float (this.pos) and only round when writing it back, so it
  advances reliably. While the shopper is interacting (or just did), pos follows
  the real scroll position, so manual scrolling is never fought. Idle-based pacing
  means no missed touch event can freeze it. Off under reduced motion.
*/
(function () {
  'use strict';

  var IDLE_MS = 1400;

  class GiftGoCatstrip extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.giftgo-catstrip__row');
      this.track = this.querySelector('.giftgo-catstrip__track');
      if (!this.row || !this.track) return;

      this.sets = this.track.querySelectorAll('.giftgo-catstrip__set').length || 1;
      if (this.sets < 3) return; // not enough copies to loop safely

      this.speed = 0.6; // px per frame
      this.pos = 0;
      this.lastInteract = 0;
      this.hovering = false;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var mark = function () { this.lastInteract = Date.now(); }.bind(this);
      ['pointerdown', 'touchstart', 'touchmove', 'wheel'].forEach(
        function (e) { this.row.addEventListener(e, mark, { passive: true }); }.bind(this)
      );
      this.row.addEventListener('mouseenter', function () { this.hovering = true; }.bind(this), { passive: true });
      this.row.addEventListener('mouseleave', function () { this.hovering = false; }.bind(this), { passive: true });

      requestAnimationFrame(this.start.bind(this));
    }

    setWidth() {
      return this.track.scrollWidth / this.sets;
    }

    start() {
      this.pos = this.setWidth() * Math.floor(this.sets / 2);
      this.row.scrollLeft = Math.round(this.pos);
      if (!this.reduce) this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    tick() {
      var idle = Date.now() - this.lastInteract > IDLE_MS;
      if (idle && !this.hovering) {
        this.pos += this.speed;
        // Keep the position in the middle sets; jumping by a whole set width is
        // seamless because the pill set is tiled.
        var w = this.setWidth();
        if (w) {
          if (this.pos > w * (this.sets - 1)) this.pos -= w;
          else if (this.pos < w) this.pos += w;
        }
        this.row.scrollLeft = Math.round(this.pos);
      } else {
        // Interacting (or within the idle window): follow the real position so a
        // manual swipe is never snapped back.
        this.pos = this.row.scrollLeft;
      }
      this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
    }
  }

  if (!customElements.get('giftgo-catstrip')) {
    customElements.define('giftgo-catstrip', GiftGoCatstrip);
  }
})();
